// extracted by mini-css-extract-plugin
export default {"container":"oaTfo","dot":"GNNJ8","small":"cVK8i","opacitychange":"Fru0u"};